import { AdminState } from '../../../../@types';

const initialState: AdminState = {
  email: '',
  admin: null,
  basicAuth: null,
};
export default initialState;
